import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ExerciseQuestionsFragmentDoc } from './ExerciseQuestions';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type ExerciseContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, status: Types.ResourceStatusEnum, exerciseObjective?: string | null, instruction?: { text?: string | null } | null, exerciseQuestions: Array<{ id: string, text: string, responseType: Types.ResourceResponseTypeEnum, medias?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, imageHotspots?: Array<{ mediaId: string, hotspots: Array<{ id: string, x: number, y: number }> }> | null, customRatingComponent?: { ratingLabels: Array<{ labelName: string, rating?: number | null }> } | null }>, cover?: { url?: string | null } | null, reviewerConfig?: { type: Types.ReviewerTypeEnum } | null, bookmark?: { id: string } | null };


export type ExerciseContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ExerciseContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, status: Types.ResourceStatusEnum, exerciseObjective?: string | null, instruction?: { text?: string | null } | null, exerciseQuestions: Array<{ id: string, text: string, responseType: Types.ResourceResponseTypeEnum, medias?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, imageHotspots?: Array<{ mediaId: string, hotspots: Array<{ id: string, x: number, y: number }> }> | null, customRatingComponent?: { ratingLabels: Array<{ labelName: string, rating?: number | null }> } | null }>, cover?: { url?: string | null } | null, reviewerConfig?: { type: Types.ReviewerTypeEnum } | null, bookmark?: { id: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type ExerciseContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ExerciseContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment ExerciseContentCard on ExerciseType {
  id
  name
  type
  duration
  status
  exerciseObjective: objective
  instruction {
    text
  }
  exerciseQuestions {
    ...ExerciseQuestions
  }
  cover {
    url
  }
  reviewerConfig {
    type
  }
  bookmark {
    id
  }
}
    `;
export const ExerciseContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ExerciseContentCardWithUserPerformance on ExerciseType {
  id
  name
  type
  duration
  status
  exerciseObjective: objective
  instruction {
    text
  }
  exerciseQuestions {
    ...ExerciseQuestions
  }
  cover {
    url
  }
  reviewerConfig {
    type
  }
  bookmark {
    id
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;